/**
 * Created by glopez on 24/04/17.
 */
import {ConfirmStatus, ActionTypes} from 'store/actions/modals/confirm';

/**
 * Status logic for state change.
 *
 * @param {Object} state - State of the component.
 * @param {Object} action - Payload for the action.
 * @returns {Object} Next state of the component.
 */
function status (state = ConfirmStatus.INITIAL, action) {

    switch (action.type) {

        case ActionTypes.SET_CONFIRM_STATUS:
            return action.status;

        default:
            return state;
    }
}

/**
 * Form data logic for state change.
 *
 * @param {Object} state - State of the component.
 * @param {Object} action - Payload for the action.
 * @returns {Object} Next state of the component.
 */
function data (state = {
                   title: '',
                   subtitle: '',

                   // TODO: Implement acceptHandler.
                   // TODO: Implement cancelHandler.

                   /* eslint-disable no-alert */
                   acceptHandler: () => alert('Not implemented yet'),
                   cancelHandler: () => alert('Not implemented yet')
                   /* eslint-enable no-alert */

               }, action) {

    switch (action.type) {

        case ActionTypes.SET_CONFIRM_DATA:
            return {
                ...action
            };

        default:
            return state;
    }
}

/**
 * Error logic for state change.
 *
 * @param {Object} state - State of the component.
 * @param {Object} action - Payload for the action.
 * @returns {Object} Next state of the component.
 */
function error (state = '', action) {

    switch (action.type) {

        case ActionTypes.SET_CONFIRM_ERROR:
            return action.error || '';

        default:
            return state;
    }
}

/**
 * Confirm reducer.
 *
 * @param {Object} state - State of the component.
 * @param {Object} action - Action payload.
 * @returns {Object} Confirm reducer.
 */
export default function confirm (state = {}, action) {

    return {
        status: status(state.status, action),
        data: data(state.data, action),
        error: error(state.error, action)
    };
}


// WEBPACK FOOTER //
// ./src/js/store/reducers/modals/confirm.js